var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpPage",
    {
      attrs: {
        size: _vm.size,
        header: _vm.documentTitle,
        loaded: _vm.loaded,
        noShow: !_vm.loaded,
        modal: _vm.modal,
        "itp-cname": "SettingsInvoicing",
        modalBindings: _vm.b_7315092382398562_modalBindings
      },
      on: {
        close: function($event) {
          return _vm.evh_7315092382398562_close($event, {})
        }
      }
    },
    [
      _vm.loaded
        ? _c(
            "DIV",
            { staticClass: "overflow-auto h-100 p-3" },
            [
              _c(
                "ItpBox",
                { staticClass: "mb-3", attrs: { alignItems: "center" } },
                [
                  _c("strong", [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm._f("pgettext")(
                            "Invoicing configuration",
                            "Settings"
                          )
                        ) +
                        "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c("ItpButton", {
                    staticClass: "ml-3",
                    attrs: {
                      icon: "fa-sync-alt",
                      text: _vm._f("gettext")("Reload"),
                      variant: "light",
                      size: "sm",
                      spinning: _vm.actions.reload.isRunning
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.evh_8320016629450276_clickPreventStop(
                          $event,
                          {}
                        )
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.loaded
                ? _c("ItpDataTable", {
                    ref: "table",
                    staticClass: "h-100",
                    attrs: {
                      tableId: "Settings.Invoicing",
                      editable: "",
                      isRowEditable: function(p) {
                        return !p.locked
                      },
                      value: _vm.items,
                      "no-create-row": "",
                      "no-delete-row": "",
                      globs: {
                        configureNumbering: _vm.configureNumbering,
                        configureProvider: _vm.configureProvider
                      },
                      columns: _vm.b_3343864469950044_columns
                    },
                    on: {
                      save: function($event) {
                        return _vm.evh_3343864469950044_save($event, {})
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded ? _c("template", { slot: "footer" }) : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }